export const furnitureData = [
  {
    id: 1,
    title: 'Modern Grey Sectional',
    description: 'Spacious sectional with clean lines and premium upholstery, perfect for contemporary living spaces.',
    category: 'sectionals',
    categoryLabel: 'Sectionals',
    style: 'Contemporary',
    image: 'https://images.unsplash.com/photo-1759722668385-90006d9c7aa7'
  },
  {
    id: 2,
    title: 'Classic Green Sofa',
    description: 'Elegant sofa with modern lines and rich green upholstery, adds sophistication to any room.',
    category: 'sofas',
    categoryLabel: 'Sofas',
    style: 'Modern Classic',
    image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc'
  },
  {
    id: 3,
    title: 'Beige Comfort Sofa',
    description: 'Luxurious beige sofa with plush cushioning and timeless design.',
    category: 'sofas',
    categoryLabel: 'Sofas',
    style: 'Traditional',
    image: 'https://images.unsplash.com/photo-1578500494198-246f612d3b3d'
  },
  {
    id: 4,
    title: 'Tufted Brown Sofa',
    description: 'Expertly crafted tufted sofa showcasing detailed upholstery work and classic styling.',
    category: 'sofas',
    categoryLabel: 'Sofas',
    style: 'Classic',
    image: 'https://images.pexels.com/photos/6372820/pexels-photo-6372820.jpeg'
  },
  {
    id: 5,
    title: 'Contemporary Blue Sofa',
    description: 'Stunning blue upholstered sofa with modern silhouette and comfortable seating.',
    category: 'sofas',
    categoryLabel: 'Sofas',
    style: 'Contemporary',
    image: 'https://images.pexels.com/photos/2986011/pexels-photo-2986011.jpeg'
  },
  {
    id: 6,
    title: 'Minimalist Grey Sectional',
    description: 'Sleek sectional design with exceptional comfort and modern aesthetic.',
    category: 'sectionals',
    categoryLabel: 'Sectionals',
    style: 'Minimalist',
    image: 'https://images.unsplash.com/photo-1759722668253-1767030ad9b2'
  },
  {
    id: 7,
    title: 'Yellow Accent Chair',
    description: 'Bold yellow upholstered armchair with elegant curves and premium fabric.',
    category: 'chairs',
    categoryLabel: 'Chairs',
    style: 'Modern',
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7'
  },
  {
    id: 8,
    title: 'Tufted Leather Chairs',
    description: 'Luxurious tufted leather chairs showcasing traditional craftsmanship.',
    category: 'chairs',
    categoryLabel: 'Chairs',
    style: 'Traditional',
    image: 'https://images.unsplash.com/photo-1669246847479-1ea00edf66ad'
  },
  {
    id: 9,
    title: 'White Upholstered Armchair',
    description: 'Elegant white armchair with classic design and comfortable seating.',
    category: 'chairs',
    categoryLabel: 'Chairs',
    style: 'Classic',
    image: 'https://images.unsplash.com/photo-1768573264026-b540abdc3384'
  },
  {
    id: 10,
    title: 'Beige Recliner Chair',
    description: 'Comfortable recliner with premium upholstery and modern functionality.',
    category: 'chairs',
    categoryLabel: 'Chairs',
    style: 'Contemporary',
    image: 'https://images.unsplash.com/photo-1757969687802-82493a29047a'
  },
  {
    id: 11,
    title: 'Grey Dining Chair',
    description: 'Sophisticated upholstered dining chair with clean lines and quality construction.',
    category: 'dining-chairs',
    categoryLabel: 'Dining Chairs',
    style: 'Modern',
    image: 'https://images.unsplash.com/photo-1598300042247-d088f8ab3a91'
  },
  {
    id: 12,
    title: 'Modern Grey Sofa',
    description: 'Sleek grey sofa with contemporary design perfect for modern interiors.',
    category: 'sofas',
    categoryLabel: 'Sofas',
    style: 'Contemporary',
    image: 'https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e'
  }
];
